import { render, staticRenderFns } from "./SfSlidingSection.vue?vue&type=template&id=faaaad92&"
import script from "./SfSlidingSection.vue?vue&type=script&lang=js&"
export * from "./SfSlidingSection.vue?vue&type=script&lang=js&"
import style0 from "./SfSlidingSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports